import { request, unwrap } from '../client';
import type {
  ApiResponse,
  EmailTemplateDto,
  UpsertEmailTemplateRequest,
} from '../types';

export const emailTemplatesApi = {
  async list(tenantId: number): Promise<EmailTemplateDto[]> {
    const res = await request<ApiResponse<EmailTemplateDto[]>>(
      'GET',
      `/api/saas-admin/tenants/${tenantId}/email-templates`,
    );
    return unwrap(res);
  },

  async upsert(tenantId: number, req: UpsertEmailTemplateRequest): Promise<EmailTemplateDto> {
    const res = await request<ApiResponse<EmailTemplateDto>>(
      'PUT',
      `/api/saas-admin/tenants/${tenantId}/email-templates`,
      { json: req },
    );
    return unwrap(res);
  },

  async delete(tenantId: number, templateId: number): Promise<void> {
    await request<void>(
      'DELETE',
      `/api/saas-admin/tenants/${tenantId}/email-templates/${templateId}`,
    );
  },
};
